export default __webpack_public_path__ + "images/KC.cb75dc8.png";